import cn from "classnames";
import React from "react";

const RulesAndTerms = ({
  checkBoxes,
  handleCheckboxChange,
  checkboxErrors,
  handleTermClick,
}) => {
  return (
    <div
      className={
        "font-inter px-8 pt-3 pb-4 w-full flex flex-col gap-2 border-b border-lightGrayBlue dark:border-darkSlateBlue"
      }
    >
      <form className="flex gap-3">
        <div className="h-7 flex items-center">
          <input
            type="checkbox"
            id="checkbox1"
            className="h-[14px] w-[14px] custom-checkbox"
            checked={checkBoxes.terms3}
            onChange={() => handleCheckboxChange("terms3")}
          />
        </div>
        <label
          htmlFor="checkbox1"
          className={cn(
            "text-semiBlack dark:text-semiWhite text-xs md:text-base leading-4 md:leading-6 ali",
            {
              "!text-black dark:!text-white": checkBoxes.terms3,
            }
          )}
        >
          I have read, understand and agree that X Bull Run Founder’s Nodes are{" "}
          <button
            type="button"
            className={cn(
              "text-semiBlack dark:text-semiWhite text-xs leading-4 md:text-base md:leading-6 font-bold",
              {
                "!text-black dark:!text-white": checkBoxes.terms3,
              }
            )}
            onClick={() => handleTermClick("terms3")}
          >
            Not investments
          </button>
        </label>
        {checkboxErrors.terms3 && (
          <p className="text-red-600 text-sm">
            Please agree that nodes are not investments.
          </p>
        )}
      </form>

      <form className="flex gap-3 items-center">
        <div className="h-5 flex items-center justify-center">
          <input
            type="checkbox"
            id="checkbox2"
            className="custom-checkbox"
            checked={checkBoxes.terms1}
            onChange={() => handleCheckboxChange("terms1")}
          />
        </div>
        <label
          htmlFor="checkbox2"
          className={cn(
            "text-semiBlack dark:text-semiWhite text-xs md:text-base leading-4 md:leading-6 ali",
            {
              "!text-black dark:!text-white": checkBoxes.terms1,
            }
          )}
        >
          I have read, understand and agree to the{" "}
          <button
            type="button"
            className={cn(
              "text-semiBlack dark:text-semiWhite text-xs leading-4 md:text-base md:leading-6 font-bold",
              {
                "!text-black dark:!text-white": checkBoxes.terms1,
              }
            )}
            onClick={() => handleTermClick("terms1")}
          >
            Terms of Service
          </button>
        </label>
        {checkboxErrors.terms1 && (
          <p className="text-red-600 text-sm">
            Please agree to the Terms of Service.
          </p>
        )}
      </form>

      <form className="flex gap-3 items-center">
        <div className="h-5 flex items-center justify-center">
          <input
            type="checkbox"
            id="checkbox3"
            className="custom-checkbox"
            checked={checkBoxes.terms2}
            onChange={() => handleCheckboxChange("terms2")}
          />
        </div>
        <label
          htmlFor="checkbox3"
          className={cn(
            "text-semiBlack dark:text-semiWhite text-xs md:text-base leading-4 md:leading-6 ali",
            {
              "!text-black dark:!text-white": checkBoxes.terms2,
            }
          )}
        >
          I have read, understand and agree to the{" "}
          <button
            type="button"
            className={cn(
              "text-semiBlack dark:text-semiWhite text-xs leading-4 md:text-base md:leading-6 font-bold",
              {
                "!text-black dark:!text-white": checkBoxes.terms2,
              }
            )}
            onClick={() => handleTermClick("terms2")}
          >
            Privacy Policy.
          </button>
        </label>
        {checkboxErrors.terms2 && (
          <p className="text-red-600 text-sm">
            Please agree to the Privacy Policy.
          </p>
        )}
      </form>
    </div>
  );
};

export default RulesAndTerms;
